// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","sunInfo":"sunInfo-3MScP","sunInfo__inner":"sunInfo__inner-3dOp3"};